import {
  QuotaionOffersPublicResponse,
  QuotationOffersPublic,
  QuotationsOffersPublicSend,
} from './QuotationsOffers.types';

import { publicInstance } from '@/api/axiosInstance';

import { PageResult } from '@/core/request/PageResult';
import {
  ListManufacturersQuery,
  Manufacturer,
} from '@/core/domain/operational/Manufacturers/Manufacturers.types';

export async function getQuotationOffersPublic(guid: string) {
  const result = await publicInstance.get<QuotaionOffersPublicResponse>(
    `/stock/v1/quotations/offers/public/${guid}`,
  );

  return result.data;
}

export async function quotationOffersPublicSend(
  data: QuotationsOffersPublicSend,
) {
  const result = await publicInstance.post<QuotationOffersPublic>(
    `/stock/v1/quotations/offers/${data.code}`,
    data,
  );

  return result.data;
}

export async function getManufacturersPublic(params: ListManufacturersQuery) {
  const result = await publicInstance.get<PageResult<Manufacturer>>(
    `/operational/v1/manufacturers/public`,
    { params },
  );

  return result.data;
}

export async function detailManufacturerPublic(id: number) {
  const result = await publicInstance.get<Manufacturer>(
    `/operational/v1/manufacturers/public/${id}`,
  );

  return result.data;
}
